import { cloneDeep } from "lodash";

const SET_FWU_VERSIONS = "app/fwuVersions/SET_FWU_VERSIONS";
const RESET_FWU_VERSIONS = "app/fwuVersions/RESET_FWU_CAMPAIGNS";
const SET_FWU_VERSION_TO_EDIT = "app/fwuVersions/SET_FWU_VERSION_TO_EDIT";
const SET_FWU_VERSION_TO_DELETE = "app/fwuVersions/SET_FWU_VERSION_TO_DELETE";
const SET_RELEASE_NOTES = "app/fwuVersions/SET_RELEASE_NOTES";
const PUSH_RELEASE_NOTES_MEDIA = "app/fwuVersions/PUSH_RELEASE_NOTES_MEDIA";
const RESET_RELEASE_NOTES_MEDIA = "app/fwuVersions/RESET_RELEASE_NOTES_MEDIA";
const PUSH_RELEASE_NOTES_THUMBNAILS = "app/fwuVersions/PUSH_RELEASE_NOTES_THUMBNAILS";
const RESET_RELEASE_NOTES_THUMBNAILS = "app/fwuVersions/RESET_RELEASE_NOTES_THUMBNAILS";
const SET_RELEASE_NOTES_LOADING = "app/fwuVersions/SET_RELEASE_NOTES_LOADING";
const SET_LOADING_CHANGES = "app/fwuVersions/SET_LOADING_CHANGES";
const SET_LOADING = "app/fwuVersions/SET_LOADING";
const SET_REFRESH = "app/fwuVersions/SET_REFRESH";
const SET_ERROR = "app/fwuVersions/SET_ERROR";

const initialState = {
  fwuVersions: [],
  fwuVersionToEdit: null,
  fwuVersionToDelete: null,
  releaseNotes: null,
  releaseNotesMedia: [],
  releaseNotesThumbnails: [],
  releaseNotesLoading: false,
  loadingChanges: false,
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FWU_VERSIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuVersions: action.payload
      };
    }

    case RESET_FWU_VERSIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuVersions: []
      };
    }

    case SET_FWU_VERSION_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuVersionToEdit: action.payload
      };
    }

    case SET_FWU_VERSION_TO_DELETE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuVersionToDelete: action.payload
      };
    }

    case SET_RELEASE_NOTES: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotes: action.payload
      };
    }

    case PUSH_RELEASE_NOTES_MEDIA: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesMedia: [...clonedState.releaseNotesMedia, action.payload]
      };
    }

    case RESET_RELEASE_NOTES_MEDIA: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesMedia: []
      };
    }

    case PUSH_RELEASE_NOTES_THUMBNAILS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesThumbnails: [...clonedState.releaseNotesThumbnails, action.payload]
      };
    }

    case RESET_RELEASE_NOTES_THUMBNAILS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesThumbnails: []
      };
    }

    case SET_RELEASE_NOTES_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesLoading: action.payload
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING_CHANGES: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loadingChanges: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setFWUVersions = (fwuVersions) => ({
  type: SET_FWU_VERSIONS,
  payload: fwuVersions
});

export const resetFWUVersions = () => ({ type: RESET_FWU_VERSIONS });

export const setFWUVersionToEdit = (fwuVersion) => ({
  type: SET_FWU_VERSION_TO_EDIT,
  payload: fwuVersion
});

export const setFWUVersionToDelete = (fwuVersion) => ({
  type: SET_FWU_VERSION_TO_DELETE,
  payload: fwuVersion
});

export const setReleaseNotes = (releaseNotes) => ({
  type: SET_RELEASE_NOTES,
  payload: releaseNotes
});

export const pushReleaseNotesMedia = (iconData) => ({
  type: PUSH_RELEASE_NOTES_MEDIA,
  payload: iconData
});

export const resetReleaseNotesMedia = () => ({
  type: RESET_RELEASE_NOTES_MEDIA
});

export const pushReleaseNotesThumbnails = (thumbnailsData) => ({
  type: PUSH_RELEASE_NOTES_THUMBNAILS,
  payload: thumbnailsData
});

export const resetReleaseNotesThumbnails = () => ({
  type: RESET_RELEASE_NOTES_THUMBNAILS
});

export const setReleaseNotesLoading = (loading) => ({
  type: SET_RELEASE_NOTES_LOADING,
  payload: loading
});

export const setLoadingChanges = (loading) => ({ type: SET_LOADING_CHANGES, payload: loading });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
